/**
 * @packageDocumentation
 * @module f1/array
 */

import { t_arr } from '../types';

export interface Nth {
  /**
   * Get the index of a sequential (string or array) data structure
   *
   * @public
   * @function f1.nth
   * @param index index in to the value
   * @param value select a single value from this element
   * @example
   *
   * ```ts
   * nth(3, [1, 2, 3, 4]) === 4
   * nth(3, 'abcde') === 'd'
   * nth(-1, 'abcde') === 'e'
   * ```
   */
  <T>(index: number, u: t_arr<T>): T;
  <T>(index: number, u: string): string;
  <T>(index: number, u: t_arr<T> | string): T | string;
  <T>(index: number): (u: t_arr<T> | string) => T | string;
}

/**
 * @see Nth
 */
function nth<T>(index: number, u: t_arr<T>): T;
function nth<T>(index: number, u: string): string;
function nth<T>(index: number, u: t_arr<T> | string): T | string {
  // @todo share this method with other numerical indexing
  const base = index < 0 ? u.length : 0;

  // @note the index could still not hit
  return u[base + index];
}

export default nth;
